(function () {
  "use strict";

  function createProductAccordions(scope) {
    scope = scope || document;

    var descriptions = scope.querySelectorAll(
      ".section-main-product .product-description.rte:not([data-jy-accordion-ready]), " +
      ".section-main-product .product-description.rte.cf:not([data-jy-accordion-ready])"
    );

    descriptions.forEach(function (description) {
      var headings = Array.prototype.slice.call(
        description.querySelectorAll(":scope > h3")
      );

      if (!headings.length) return;

      description.setAttribute("data-jy-accordion-ready", "true");

      var accordionGroup = document.createElement("div");
      accordionGroup.className = "jy-product-accordions";

      /*
       * Content appearing before the first H3 is retained above the accordions.
       */
      var firstHeading = headings[0];
      var leadingNodes = [];

      while (
        description.firstChild &&
        description.firstChild !== firstHeading
      ) {
        leadingNodes.push(description.firstChild);
        description.removeChild(description.firstChild);
      }

      leadingNodes.forEach(function (node) {
        description.insertBefore(node, description.firstChild);
      });

      headings.forEach(function (heading, index) {
        var details = document.createElement("details");
        details.className = "jy-product-accordion";
        details.open = index === 0;

        var summary = document.createElement("summary");
        summary.className = "jy-product-accordion__heading";

        /*
         * The visible heading is still a real H3 for structure and SEO.
         */
        var headingTag = document.createElement("h3");
        headingTag.className = "jy-product-accordion__title";
        headingTag.innerHTML = heading.innerHTML;

        var icon = document.createElement("span");
        icon.className = "jy-product-accordion__icon";
        icon.setAttribute("aria-hidden", "true");

        summary.appendChild(headingTag);
        summary.appendChild(icon);

        var content = document.createElement("div");
        content.className = "jy-product-accordion__content";

        var currentNode = heading.nextSibling;

        while (
          currentNode &&
          !(
            currentNode.nodeType === 1 &&
            currentNode.tagName.toLowerCase() === "h3"
          )
        ) {
          var nextNode = currentNode.nextSibling;
          content.appendChild(currentNode);
          currentNode = nextNode;
        }

        heading.remove();

        details.appendChild(summary);
        details.appendChild(content);
        accordionGroup.appendChild(details);
      });

      description.appendChild(accordionGroup);

      var accordions = Array.prototype.slice.call(
        accordionGroup.querySelectorAll(".jy-product-accordion")
      );

      accordions.forEach(function (accordion) {
        accordion.addEventListener("toggle", function () {
          if (!accordion.open) return;

          accordions.forEach(function (otherAccordion) {
            if (otherAccordion !== accordion) {
              otherAccordion.open = false;
            }
          });
        });
      });
    });
  }

  function initialise() {
    createProductAccordions(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise);
  } else {
    initialise();
  }

  /*
   * Reinitialise when Shopify reloads a section inside the Theme Editor.
   */
  document.addEventListener("shopify:section:load", function (event) {
    createProductAccordions(event.target);
  });
})();